<template>
	<div id="coce-footer" class="h-20 w-full bg-fau-blue relative flex justify-between items-center md:justify-between md:px-16 px-8">
	      <img class="h-[40px]" src="../assets/logo-owl.svg" alt="" />
	      <span class="ml-4 text-white text-sm md:text-base font-medium leading-tight text-right">Florida Atlantic Online</span>
	    </div>
</template>
